module.exports = __webpack_public_path__ + "assets/img/logout.9be2c01f.svg";